import type { ManufacturingOrderStatus } from '@/stores/app.store'

export type HealthResponse = string

export type GetManufacturingOrderResponse = {
  id: string
  productId: string
  orderNumber: number
  status: ManufacturingOrderStatus
  productUnitCode: string
  primaryColorName: string
  secondaryColorName: string
  primaryColorHex: string
  secondaryColorHex: string
  year: number
  total: number
  checked: number
  problem: number
  imageUrl?: string
  dataLoadedAt: Date
  material: string
  description: string
  size: string
}

export type GetProductForManufacturingOrderResponse = {
  productUnitId: string
  description: string
  size: string
  year: string
  primaryColorHex: string
  secondaryColorHex: string
  serialNumber: string
  loadedAt?: Date
  autoGeneratedSerialNumber: boolean
}

export type GetReadProductResponse = {
  description: string
  size: string
  year: string
  primaryColorHex: string
  secondaryColorHex: string
  serialNumber: string
  loadedAt?: Date
}

export type AttestToProductConformityResponse = {
  isLast: boolean
  autoGeneratedSerialNumber: string | null
}

export type ListWebhooksByActivityIdResponse = {
  id: string
  name: string
  trigger: 'ATTESTED_TO_CONFORMITY'
}[]

export type OperatorLoginResponse = {
  jwtToken: string
  expiresOn: Date
}

export type ProductionDataDto = {
  serialNumber: string
  appointedAt: Date | string
  conformant: boolean
  productionOrder: {
    orderNumber: string
  }
  productUnit: {
    sku: string
    color?: {
      name: string
      hex: string
    }
    size?: string
    model?: string
  }
}

export type ListProductionDataResponse = {
  productionSequence: string
  operation: string
  history: ProductionDataDto[]
}

export type OperatorLoginError = {
  name: string
  message: string
}

export interface NonConformityReason {
  id?: string
  reason: string
  order: number
}

export type ListNonConformityReasonsResponse = {
  nonConformityReasons: NonConformityReason[]
  hasNextPage: boolean
  totalRecords: number
}

export type ListShippingResponse = ShippingDto[]

export type ListShippingReceiptResponse = ShippingReceiptDto[]

export type ShippingReceiptDto = {
  id: string
  receiptCode: string
  cnpjDest: string
  totalVolume: number
  invoiceDate: Date
  isGrouped: boolean
  carrier: string
  barCode1: string
  barCode2: string
  status: ShippingReceiptStatus
  products: ShippingReceiptProductDto[]
  carrierTags: ShippingReceiptCarrierTag[]
}

export type ShippingReceiptProductDto = {
  id: string
  productId: string
  productCode: string
  productDescription: string
  productQuantity: number
  quantityAttested?: number
}

export type ShippingReceiptCarrierTag = {
  id: string
  barCode1: string
  barCode2: string | null
  productUnitId: string
}

type ShippingDto = {
  id: string
  carrier: string
  invoiceDate: Date
  totalItems: number
  shippingReceiptQuantity: number
  status: ShippingStatus
  totalAttestedItems: number
  isGrouped: boolean
}

export enum ShippingStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  RELEASED = 'RELEASED'
}

export enum ShippingReceiptStatus {
  PENDING = 'PENDING',
  RELEASED = 'RELEASED',
  COMPLETED = 'COMPLETED'
}

export type Activity = {
  id: string
  name: string
}
